export enum Operator {
  AND = 'op$AND',
  OR = 'op$OR',
}
